import React from 'react';
import { Link } from 'react-router-dom';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { ListItemIcon, ListItemText, Tooltip } from '@mui/material';

import { getDataCenterPagePath } from '@/pages/DataCenter/v3/dataCenterPage';

import {
  collapsibleItemSx,
  getCollapsibleButtonSx,
  StyledNavButtonOutlined
} from './Sidebar';

interface DataCenterNavButtonProps {
  expanded: boolean;
  selected: boolean;
}

const DataCenterNavButton: React.FC<DataCenterNavButtonProps> = ({
  expanded,
  selected
}) => (
  <Tooltip
    title={expanded ? '' : 'Data Center'}
    placement="right"
    disableInteractive
    disableHoverListener={expanded}
  >
    <StyledNavButtonOutlined
      // @ts-ignore
      component={Link}
      to={getDataCenterPagePath({ kind: 'overview' })}
      selected={selected}
      data-chmln="nav-data-center"
      sx={{
        ...getCollapsibleButtonSx(expanded),
        justifyContent: 'center',
        padding: expanded ? '6px 16px' : 0
      }}
    >
      <ListItemIcon sx={collapsibleItemSx}>
        <AssessmentIcon
          sx={{
            fontSize: '24px',
            color: (theme) => `${theme.palette.primary.main} !important`
          }}
        />
      </ListItemIcon>
      {expanded && (
        <ListItemText
          sx={{ flex: 1, margin: 0 }}
          primary="Data Center"
          secondary="Reporting & Analytics"
        />
      )}
    </StyledNavButtonOutlined>
  </Tooltip>
);

export default DataCenterNavButton;
